import { SIGNIN } from "constants/url";
import { RouteObject } from "react-router-dom";

export default [
  {
    path: SIGNIN,
    lazy: () => import("modules/auth/pages/AuthSignIn"),
  },
] as RouteObject[];
